//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import angular from 'angular';

export default angular.module('curalate.syndication', ['curalate']);
